import React from 'react';
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { GoogleFontSelector } from './GoogleFontSelector';
import { CustomFontUpload } from './CustomFontUpload';

interface FontSourceSelectorProps {
  fontSource: 'google' | 'custom';
  onSourceChange: (source: 'google' | 'custom') => void;
  selectedGoogleFont: string;
  onGoogleFontChange: (font: string) => void;
  customFontFile: File | null;
  onCustomFontChange: (file: File | null) => void;
  uploading: boolean;
  currentCustomFontUrl?: string | null;
}

export function FontSourceSelector({
  fontSource,
  onSourceChange,
  selectedGoogleFont,
  onGoogleFontChange,
  customFontFile,
  onCustomFontChange,
  uploading,
  currentCustomFontUrl
}: FontSourceSelectorProps) {
  return (
    <RadioGroup value={fontSource} onValueChange={onSourceChange}>
      <div className="space-y-4">
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="google" id="google" />
          <Label htmlFor="google" className="font-medium">Google Fonts</Label>
        </div>
        
        {fontSource === 'google' && (
          <GoogleFontSelector 
            selectedFont={selectedGoogleFont}
            onFontChange={onGoogleFontChange}
          />
        )}

        <div className="flex items-center space-x-2">
          <RadioGroupItem value="custom" id="custom" />
          <Label htmlFor="custom" className="font-medium">Custom Font</Label>
        </div>

        {fontSource === 'custom' && (
          <CustomFontUpload
            customFontFile={customFontFile}
            onFileChange={onCustomFontChange}
            uploading={uploading}
            currentFontUrl={currentCustomFontUrl}
          />
        )}
      </div>
    </RadioGroup>
  );
}